var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarcodeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 0.447716 0.447715 0 1 0C1.55228 0 2 0.447715 2 1V13C2 13.5523 1.55228 14 1 14C0.447715 14 0 13.5523 0 13V1Z",
    fill: "#7D7D7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 1C4 0.447716 4.44772 0 5 0C5.55228 0 6 0.447715 6 1V9C6 9.55228 5.55228 10 5 10C4.44772 10 4 9.55229 4 9V1Z",
    fill: "#7D7D7D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12C4.44772 12 4 12.4477 4 13C4 13.5523 4.44772 14 5 14C5.55228 14 6 13.5523 6 13C6 12.4477 5.55228 12 5 12Z",
    fill: "#7D7D7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13C12 12.4477 12.4477 12 13 12C13.5523 12 14 12.4477 14 13C14 13.5523 13.5523 14 13 14C12.4477 14 12 13.5523 12 13Z",
    fill: "#7D7D7D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C8.44771 0 8 0.447716 8 1V13C8 13.5523 8.44771 14 9 14C9.55229 14 10 13.5523 10 13V1C10 0.447715 9.55229 0 9 0Z",
    fill: "#7D7D7D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C12 0.447716 12.4477 0 13 0C13.5523 0 14 0.447715 14 1V9C14 9.55228 13.5523 10 13 10C12.4477 10 12 9.55229 12 9V1Z",
    fill: "#7D7D7D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 0C16.4477 0 16 0.447716 16 1V13C16 13.5523 16.4477 14 17 14C17.5523 14 18 13.5523 18 13V1C18 0.447715 17.5523 0 17 0Z",
    fill: "#7D7D7D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeIcon);
export default __webpack_public_path__ + "static/media/barcode-icon.0452bcae0f0190d226dcc3d4ce7aca3a.svg";
export { ForwardRef as ReactComponent };